<template>
  <Transition name="fade">
    <div v-if="teachDesc.length" class="teacher">
      <el-carousel height="150px">
        <el-carousel-item v-for="item in teachDesc" :key="item._id">
          <div class="tea-desc">
            <RouterLink target="_blank" :to="`${item.bannerUrl}`">
              <img v-lazy="item.bannerImg" alt="" />
              <p class="name">{{ item.bannerName }}</p>
              <p class="skill">{{ item.bannerSkill }}</p>
              <p class="teach">{{ item.bannerDesc }}</p>
              <p class="icon-listen">
                <el-icon><Headset /></el-icon>
              </p>
            </RouterLink>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <teachDescSkeleton v-else />
  </Transition>
</template>

<script>
import TeachDescSkeleton from "./teach-desc-skeleton..vue";
import { ElMessage } from "element-plus";
import { findBanner } from "@/api/home";
import { computed, ref } from "vue";
export default {
  components: {
    TeachDescSkeleton,
  },
  setup() {
    const teachDesc = ref([]);
    findBanner(1719395158630)
      .then((data) => {
        try {
          teachDesc.value = data;
        } catch (error) {
          ElMessage({
            message: error.message,
            type: "error",
            plain: true,
          });
        }
      })
      .catch((error) => {
        ElMessage({
          message: error.message,
          type: "error",
          plain: true,
        });
      });
    return { teachDesc };
  },
};
</script>

<style lang="less" scoped>
.teacher {
  background: #dfdcdc;
  :hover {
    cursor: pointer;
    color: @shColor;
  }
  .tea-desc {
    position: relative;
  }
  img {
    float: left;
  }

  .name {
    position: absolute;
    left: 35%;
    margin-top: 10%;
    font-size: 18px;
    color: rgb(51, 51, 51);
  }
  .skill {
    position: absolute;
    left: 35%;
    margin-top: 21%;
    font-size: 14px;
    color: #666;
  }
  .teach {
    position: absolute;
    left: 35%;
    margin-top: 32%;
    margin-right: 8px;
    color: rgb(51, 51, 51);
  }
  .icon-listen {
    position: absolute;
    right: 10%;
    margin-top: 125px;
    font-size: 20px;
  }

  .el-carousel {
    --el-carousel-indicator-width: 10px;
    --el-carousel-indicator-height: 2px;
  }
}
</style>
